import { useQuery } from "@tanstack/react-query";
import { getModerationQueue } from "@/services/adminApi";

const autoRefresh = import.meta.env.VITE_AUTO_REFRESH === "true";

export function useModerationQueue(limit = 20) {
  return useQuery({
    queryKey: ["admin", "moderation", "queue", limit],
    queryFn: () => getModerationQueue(limit),
    refetchInterval: autoRefresh ? 15000 : false,
  });
}
